import styled from 'styled-components';

export const StyledTrack = styled.div`
  height: 10px;
  width: 100%;
  background-color: ${props => props.theme.colors.text.secondary};
`;

export const StyledIndicator = styled.span`
  display: block;
  background-color: ${props => props.theme.colors.secondary.egg};
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  height: 100%;
  width: ${props => props.progress}%;
  transition: width 1s ease-in-out;
`;
